/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthTwitchConnectRequest
 */
export interface FxIdWebFeaturesAuthTwitchConnectRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthTwitchConnectRequest
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthTwitchConnectRequest
     */
    Code: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthTwitchConnectRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthTwitchConnectRequest(value: object): value is FxIdWebFeaturesAuthTwitchConnectRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('Code' in value) || value['Code'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthTwitchConnectRequestFromJSON(json: any): FxIdWebFeaturesAuthTwitchConnectRequest {
    return FxIdWebFeaturesAuthTwitchConnectRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthTwitchConnectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthTwitchConnectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'Code': json['Code'],
    };
}

export function FxIdWebFeaturesAuthTwitchConnectRequestToJSON(json: any): FxIdWebFeaturesAuthTwitchConnectRequest {
    return FxIdWebFeaturesAuthTwitchConnectRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthTwitchConnectRequestToJSONTyped(value?: FxIdWebFeaturesAuthTwitchConnectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'Code': value['Code'],
    };
}

